import {h, Component} from 'preact';
import {connect} from 'preact-redux';
import HeaderTitle from '/chat/src/components/Header/Title';
import {BackButton, CloseButton} from '/chat/src/components/Buttons';
import SystemModel from '/chat/src/redux/model/system/model';
import style from './style.scss'
import Languages from '/chat/src/languages/lang.json'
import Customization from '/chat/src/redux/model/customization/model';
import HeaderRightToolBelt from '/chat/src/components/Header/Toolbelt/RightSide'


class Header extends Component {
    render(){
        const company = this.props.company;
        const isEmpty = this.props.conversations.isEmpty();
        const route = isEmpty ? 'StartChatting': 'Conversations'
        return (
            <div className={style.Header} style={{backgroundColor: this.props.color}}>
                <HeaderTitle title={this.props.language.get("QuestionsAndAnswersWith")} body={this.props.name}/>
                <HeaderRightToolBelt>
                    <CloseButton/>
                </HeaderRightToolBelt>
            </div>
        );
    }

}

function mapStateToProps(state)
{
    const color = Customization.getColor(state);
    const language = Customization.getLanguage(state);
    const name = Customization.getCompanyDisplayName(state);
    return {
        company: state.get('company'),
        conversations: state.get('conversations'),
        color: color,
        language: language,
        name: name
    };
}

export default connect(mapStateToProps)(Header);



// WEBPACK FOOTER //
// ./routes/FAQ/Header/index.js